<div class="image pagenav">
    <img src="./assets/401.jpg">
    <div class="text">
      Page Access - Denied
    </div>
      <div class="main-text">
        Page access not present
      </div>
      <div class="text">
        Connect with admin support to get access
      </div>
</div>
  